import { ITargetContentLink } from '@/interfaces/TargetContentLink';

export class TargetContentLink implements ITargetContentLink {
  text: string;
  url: string;

  constructor(targetContentLink: ITargetContentLink) {
    if (targetContentLink) {
      this.text = targetContentLink.text;
      this.url = targetContentLink.url;
    }
  }
}
